import { useCallback, useEffect, useRef, useState} from "react";

type Message = {
  type: string;
  data: object;
}

export function useWebsocket(url: string) {
    const socketRef = useRef<WebSocket | null>(null);
    const [connected, setConnected] = useState(false);
    const [errored, setError] = useState<Event | null>(null);
    const [message, setMessage] = useState<Message | null>(null);

    useEffect(() => {
      const socket = new WebSocket(url);

      socket.onopen = () => {
        setConnected(true);
      };

      socket.onmessage = (event: MessageEvent) => {
        const message: Message = JSON.parse(event.data);
        setMessage(message);
      };

      socket.onerror = (error: Event)  => {
        setError(error);
      };

      socket.onclose = () => {
        setConnected(false);
      };

      socketRef.current = socket;

      return () => {
       socket.close();
       socketRef.current = null; 
      }
    }, [url]);

    const send = useCallback((message: Message) => {
      const socket = socketRef.current;

      if (!socket || socket.readyState !== WebSocket.OPEN) {
        console.warn("Websocket not connected");
        return;
      }

      socket.send(JSON.stringify(message));
    }, []);

    return {
      errored,
      connected,
      message,
      send
    };
}
